import { SxProps, Theme } from "@mui/material";

export function textFieldCellStyle(editable = true, edit = false): SxProps<Theme> {
	if (editable) {
		if (edit) {
			return {
				paddingTop: 0.6,
				paddingBottom: 0.5
			};
		} else {
			return {
				// width: "100%",
				cursor: "pointer"
			}
		}
	} else {
		return {};
	}
}